import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
import {
  Button,
  Card,
  Tab,
  Tabs
} from '@material-ui/core';
import { Breadcrumb, BackdropCircular} from 'components';
import { getStoreCustomerDataApi } from 'api';
import CustomerDetails from './CustomerDetails';
import CustomerAddresses from './CustomerAddresses';
import CustomerOrders from './customerOrders/CustomerOrders';
import CustomerRewardsList from './customerRewards/CustomerRewardsList';
import CustomerSubscriptions from './customerSubscriptions/CustomerSubscriptions';
import CustomerGiftCards from './customerGiftCards/CustomerGiftCards';
import EditCustomerGiftCardBalance from './customerGiftCards/EditCustomerGiftCardBalance';


const Customer = () => {
  const {id, tab} = useParams<{ id: string, tab: string }>();
  const history = useHistory();
  const dispatch = useDispatch();
  const [openEditGiftCardBalance, setOpenEditGiftCardBalance] = useState(false);

  const {
    customersData,
    loadingCustomerData,
    deletingCustomerAccount,
    loginAsCustomer,
    resetCustomerPassword,
    loadingCustomerActiveCardData
  } = useSelector((state: IReduxState) => state.customers);

  const isLoading = loadingCustomerData ||
    deletingCustomerAccount ||
    loginAsCustomer ||
    resetCustomerPassword ||
    loadingCustomerActiveCardData;

  const locationState = history.location.state as LocationState;
  const breadcrumbPath = locationState && locationState.params ? `/customers/list${locationState.params}` : '/customers/list';

  useEffect(() => {
    if (!customersData[id]) {
      getStoreCustomerDataApi({dispatch, id});
    }
  }, [id]);

  return (
    <div className="flex-grow flex-column relative h-full scroll-y pb-5">
      <div className="mb-sm-30">
        <Breadcrumb
          routeSegments={[
            { name: 'Customers', path: breadcrumbPath},
            { name: tab.replaceAll('-', ' ')}
          ]}
        />
      </div>
      <div className="flex w-full justify-end px-18">
        {tab == 'rewards' &&
          <Button
            color="primary"
            variant="contained"
            className="uppercase"
            onClick={() => history.push({
              pathname: `/customers/${id}/balance`,
            })}
          >
            Edit Balance
          </Button>
        }
        {tab == 'gift-card-credit' &&
          <Button
            color="primary"
            variant="contained"
            className="uppercase"
            onClick={() => setOpenEditGiftCardBalance(true)}
          >
            Edit Balance
          </Button>
        }
        {tab !== 'rewards' && tab !== 'gift-card-credit' &&
          <Button
            color="primary"
            variant="contained"
            className="uppercase"
            onClick={() => history.push({
              pathname: `/customers/${id}/edit`,
            })}
          >
            Edit Account Information
          </Button>
        }
      </div>
      <Card className="mx-10 my-8 overflow-visible">
        <Tabs
          value={tab}
          onChange={(_, newValue) => history.replace(`/customers/${id}/${newValue}`)}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
        >
          <Tab
            className="capitalize font-medium font-bold flex items-center px-4"
            label="Personal Information"
            value="details"
          />
          <Tab
            className="capitalize font-medium font-bold flex items-center px-4"
            label="Addresses"
            value="addresses"
          />
          <Tab
            className="capitalize font-medium font-bold flex items-center px-4"
            label="Orders"
            value="orders"
          />
          <Tab
            className="capitalize font-medium font-bold flex items-center px-4"
            label="Rewards"
            value="rewards"
          />
          <Tab
            className="capitalize font-medium font-bold flex items-center px-4"
            label="Subscriptions"
            value="subscriptions"
          />
          <Tab
            className="capitalize font-medium font-bold flex items-center px-4"
            label="Gift Card Credit"
            value="gift-card-credit"
          />
        </Tabs>
        <div className="m-8">
          {tab === 'details' && customersData[id] &&
            <CustomerDetails customer={customersData[id]} />
          }
          {tab === 'addresses' && customersData[id] &&
            <CustomerAddresses customer={customersData[id]} />
          }
          {tab === 'orders' && customersData[id] &&
            <CustomerOrders customer={customersData[id]} />
          }
          {tab === 'rewards' && customersData[id] &&
            <CustomerRewardsList customerId={id} />
          }
          {tab === 'subscriptions' && customersData[id] &&
            <CustomerSubscriptions customerId={id} />
          }
          {tab === 'gift-card-credit' && customersData[id] &&
            <CustomerGiftCards customerId={id} />
          }
        </div>
      </Card>
      <EditCustomerGiftCardBalance
        openEditForm={openEditGiftCardBalance}
        setOpenEditForm={setOpenEditGiftCardBalance}
        customerId={id}
      />
      <BackdropCircular loading={isLoading} />
    </div>
  );
};

export default Customer;
